import type { Course } from './types';

export type MatchHole = {
  id: string;
  number: number;
  par: number;
  distance?: number;
  round?: 1 | 2;
  physicalNumber?: number;
};

export function resolveMatchHoleCount(match: { holesToPlay?: number; course?: Course | null }) {
  if (typeof match.holesToPlay === 'number') {
    return match.holesToPlay;
  }
  return match.course?.holesCount ?? match.course?.holes.length ?? 9;
}

export function buildMatchHoles(course: Course | null | undefined, holesToPlay?: number): MatchHole[] {
  if (!course?.holes?.length) {
    return [];
  }

  const courseHoles = course.holes;
  const baseCount = course.holesCount ?? courseHoles.length;
  const target = holesToPlay ?? baseCount;

  if (target <= baseCount) {
    return courseHoles.slice(0, target).map(hole => ({ ...hole }));
  }

  const result: MatchHole[] = [];
  for (let index = 0; index < target; index += 1) {
    const physical = courseHoles[index % courseHoles.length];
    const round = Math.floor(index / courseHoles.length) + 1;
    result.push({
      id: `${physical.id}-round-${round}`,
      number: index + 1,
      par: physical.par,
      distance: physical.distance,
      round: round as 1 | 2,
      physicalNumber: physical.number,
    });
  }
  return result;
}

export function matchHoleLabel(hole: MatchHole) {
  if (hole.round === 2 && hole.physicalNumber) {
    return `Hole ${hole.number} · Round 2 (${hole.physicalNumber})`;
  }
  return `Hole ${hole.number}`;
}
